import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useFaqItems } from "../apis";

// The backend caps `take` at 50 — with the whole FAQ on one page the
// drag-reorder can renumber the full list safely.
const FAQ_LIST_TAKE = 50;

const useFaqItemsList = () => {
  const { page, searchValue, debouncedSearch, setSearchValue, setPage } =
    useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: FAQ_LIST_TAKE,
    search: debouncedSearch
  };

  const { faqItems, meta, isLoading, setFaqItems } =
    useFaqItems(requestParams);

  return {
    faqItems,
    totalItems: meta?.itemCount ?? 0,
    pageCount: meta?.pageCount ?? 1,
    take: FAQ_LIST_TAKE,
    searchValue,
    page,
    isLoading,
    setSearchValue,
    setPage,
    setFaqItems
  };
};

export default useFaqItemsList;
